export const OPEN_QUEUE = 'open_queue/OPEN_QUEUE';
export const CLOSE_QUEUE = 'close_queue/CLOSE_QUEUE';
